import { selfAxios } from "@oppein/op-utils";

/**
 * 保存审批配置详情（含角色配置列表和审批人配置列表，存在id做更新，不存在做新增）
 */
export async function saveAuditConfigDetail(params) {
  const { data } = await selfAxios.post(
    "/quotation/designQuotationEContractAuditController/saveAuditConfigDetail",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/quotaion/designQuotationEContractAuditController/saveAuditConfigDetail/post.js